"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "appTypes", {
  enumerable: true,
  get: function get() {
    return _SessionHandlerCic.appTypes;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "loginTypes", {
  enumerable: true,
  get: function get() {
    return _SessionHandlerCic.loginTypes;
  }
});
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _SessionHandlerCic = _interopRequireWildcard(require("./SessionHandlerCic"));
var _mainConfig = require("../mainConfig");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var engine = new _SessionHandlerCic.default();
var SessionHandler = /*#__PURE__*/function () {
  function SessionHandler() {
    (0, _classCallCheck2.default)(this, SessionHandler);
  }
  (0, _createClass2.default)(SessionHandler, null, [{
    key: "generateSSOLoginUrl",
    value: function generateSSOLoginUrl() {
      return engine.generateSSOLoginUrl();
    }
  }, {
    key: "getCurrentCodeVerifier",
    value: function getCurrentCodeVerifier() {
      var _engine;
      return (_engine = engine).getCurrentCodeVerifier.apply(_engine, arguments);
    }
  }, {
    key: "removeCodeVerifier",
    value: function removeCodeVerifier() {
      var _engine2;
      return (_engine2 = engine).removeCodeVerifier.apply(_engine2, arguments);
    }
  }, {
    key: "parseJwt",
    value: function parseJwt() {
      var _engine3;
      return (_engine3 = engine).parseJwt.apply(_engine3, arguments);
    }
  }, {
    key: "setEngine",
    value: function setEngine(driver) {
      engine = driver;
      window.destroySession = function () {
        engine.destroySession();
      };
    }
  }, {
    key: "getLogoutSuccessPage",
    value: function getLogoutSuccessPage() {
      return engine.getLogoutSuccessPage();
    }
  }, {
    key: "getRefreshToken",
    value: function getRefreshToken() {
      return engine.getRefreshToken();
    }
  }, {
    key: "setStorage",
    value: function setStorage() {
      var _engine4;
      return (_engine4 = engine).setStorage.apply(_engine4, arguments);
    }
  }, {
    key: "startSession",
    value: function startSession() {
      var _engine5;
      return (_engine5 = engine).startSession.apply(_engine5, arguments);
    }
  }, {
    key: "attachMouseListener",
    value: function attachMouseListener() {
      return engine.attachMouseListener();
    }
  }, {
    key: "initSession",
    value: function initSession() {
      var _engine6;
      return (_engine6 = engine).initSession.apply(_engine6, arguments);
    }
  }, {
    key: "getEngine",
    value: function getEngine() {
      return engine;
    }
  }, {
    key: "startExpireInterval",
    value: function startExpireInterval() {
      return engine.startExpireInterval();
    }
  }, {
    key: "getLoginType",
    value: function getLoginType() {
      return engine.getLoginType();
    }
  }, {
    key: "setLoginType",
    value: function setLoginType() {
      var _engine7;
      return (_engine7 = engine).setLoginType.apply(_engine7, arguments);
    }
  }, {
    key: "getRedirectUrl",
    value: function getRedirectUrl() {
      var _engine8;
      return (_engine8 = engine).getRedirectUrl.apply(_engine8, arguments);
    }
  }, {
    key: "destroyRemoteSso",
    value: function destroyRemoteSso() {
      var _engine9;
      return (_engine9 = engine).destroyRemoteSso.apply(_engine9, arguments);
    }
  }, {
    key: "destroyLocalSession",
    value: function destroyLocalSession() {
      var _engine0;
      return (_engine0 = engine).destroyLocalSession.apply(_engine0, arguments);
    }
  }, {
    key: "destroySession",
    value: function destroySession() {
      var _engine1;
      return (_engine1 = engine).destroySession.apply(_engine1, arguments);
    }
  }, {
    key: "getPermissions",
    value: function getPermissions() {
      return engine.getPermissions();
    }
  }, {
    key: "setPermissions",
    value: function setPermissions() {
      var _engine10;
      return (_engine10 = engine).setPermissions.apply(_engine10, arguments);
    }
  }, {
    key: "resetPermissions",
    value: function resetPermissions() {
      return engine.resetPermissions();
    }
  }, {
    key: "checkForPermissions",
    value: function checkForPermissions() {
      var _engine11;
      return (_engine11 = engine).checkForPermissions.apply(_engine11, arguments);
    }
  }, {
    key: "hasPermissionsByMwToken",
    value: function hasPermissionsByMwToken() {
      var _engine12;
      return (_engine12 = engine).hasPermissionsByMwToken.apply(_engine12, arguments);
    }
  }, {
    key: "hasPermissions",
    value: function hasPermissions() {
      var _engine13;
      return (_engine13 = engine).hasPermissions.apply(_engine13, arguments);
    }
  }, {
    key: "userMustBeLoggedIn",
    value: function userMustBeLoggedIn() {
      for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
        types[_key] = arguments[_key];
      }
      return engine.userMustBeLoggedIn([].concat(types));
    }
  }, {
    key: "isUserLoggedIn",
    value: function isUserLoggedIn() {
      for (var _len2 = arguments.length, types = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        types[_key2] = arguments[_key2];
      }
      return engine.isUserLoggedIn([].concat(types));
    }
  }, {
    key: "getName",
    value: function getName() {
      return engine.getName();
    }
  }, {
    key: "getToken",
    value: function getToken() {
      var _engine14;
      return (_engine14 = engine).getToken.apply(_engine14, arguments);
    }
  }, {
    key: "setToken",
    value: function setToken() {
      var _engine15;
      return (_engine15 = engine).setToken.apply(_engine15, arguments);
    }
  }, {
    key: "isUserAssignedToCorrectApp",
    value: function isUserAssignedToCorrectApp() {
      return this.isUserAssignedToApp(_SessionHandlerCic.appTypes.cscn) && !_mainConfig.isCICContentTree || this.isUserAssignedToApp(_SessionHandlerCic.appTypes.cic) && _mainConfig.isCICContentTree;
    }
  }, {
    key: "isUserAssignedToApp",
    value: function isUserAssignedToApp() {
      var _engine16;
      return (_engine16 = engine).isUserAssignedToApp.apply(_engine16, arguments);
    }
  }, {
    key: "setIntermediateReadingMeterNumber",
    value: function setIntermediateReadingMeterNumber(meterNumber) {
      return engine.setIntermediateReadingMeterNumber(meterNumber);
    }
  }, {
    key: "getIntermediateReadingMeterNumber",
    value: function getIntermediateReadingMeterNumber() {
      return engine.getIntermediateReadingMeterNumber();
    }
  }]);
  return SessionHandler;
}();
SessionHandler.permissionsSet = false;
window.destroySession = function () {
  SessionHandler.destroySession();
};
var _default = exports.default = SessionHandler;